import { FC, useEffect, useRef, useState } from 'react';
import styles from './entry.module.less';
import { Bucket } from '@/common/enums/qiniu';
// html2canvas 2000ms
// import html2canvas from 'html2canvas';

// htmlToImage 20ms
import * as htmlToImage from 'html-to-image';
import { getUploadCustomToken, uploadToCustom } from '@/common/utils/ways';
import { isArray, urlParams } from '@lhb/func';
import { getBrandList, saveOptimizeLogo } from '@/common/api/massImage';
import { useMethods } from '@lhb/hook';

const backgroundImg = 'backgroundImg';
const content = 'content';
const frontendField = 'close'; // 用于标识是闭店的图片
const Canvas: FC<{}> = () => {
  const ids = JSON.parse(urlParams(location.search)?.id || null);
  const [imgList, setImgList] = useState<any[]>([]); // 默认的品牌图片列表
  const [token, setToken] = useState<any>(''); // 七牛云token
  const [count, setCount] = useState<number>(0);
  const [imgLoad, setImgLoad] = useState<boolean>(false);

  const canvasRefs = useRef<any[]>([]);
  const resultListRef = useRef<any[]>([]);// 保存结果
  // const resultCloseListRef = useRef<any[]>([]);// 已闭店的合成图片
  const loadedCountRef = useRef<number>(0); // 已加载完成的图片数量

  const createPoster = async(target, index) => {
    const { ref, extraData } = target || {};
    const { frontendField: isClose } = extraData || {};
    const width = ref.offsetWidth;
    // const height = ref.offsetHeight + 40;
    const height = ref.offsetHeight;
    const options = {
      scale: window.devicePixelRatio && window.devicePixelRatio > 1 ? window.devicePixelRatio : 1,
      width,
      height,
      useCORS: true,
      allowTaint: false,
      logging: false
    };
    let data;
    try {
      data = await htmlToImage.toCanvas(ref, options);
    } catch (err) {
      console.error(err);
    }
    const base64Data = data?.toDataURL() || null;
    if (base64Data) {
      uploadToCustom(base64Data, token).then((res:any) => {
        // 获取到结果，在传出去
        // closedLogo
        const oldData = resultListRef.current;
        resultListRef.current = [...oldData, {
          id: imgList[index]?.id,
          ...(isClose ? { closedLogo: res.url } : { optimizeLogo: res.url })
        }];
        setCount((state) => state + 1);
      });
    } else {
      resultListRef.current.push({
        id: imgList[index]?.id,
        // optimizeLogo: ''
        ...(isClose ? { closedLogo: '' } : { optimizeLogo: '' })
      });
      setCount((state) => state + 1);
    }

    // 将优化后的图片上报给服务端
    if (index !== imgList.length - 1) {
      createPoster(canvasRefs.current[index + 1], index + 1);
    }
  };

  const methods = useMethods({
    checkAllLoaded() {
      loadedCountRef.current++;
      if (loadedCountRef.current === imgList.length) {
        // 这里执行图片加载完成后的操作
        setImgLoad(true);
      }
    }
  });

  // 合成后的图片上传到服务端
  useEffect(() => {
    if (count === imgList.length && count) {
      const target = resultListRef.current?.reduce?.((acc, current) => {
        const { id } = current;
        // 如果已存在该id的对象，则合并属性；否则创建新对象
        if (acc[id]) {
          acc[id] = { ...acc[id], ...current };
        } else {
          acc[id] = { ...current };
        }
        return acc;
      }, {});
      const brandImgs = Object.values(target || {});
      saveOptimizeLogo({
        optimizeLogos: brandImgs
      });
    }
  }, [imgList, count]);
  // 获取默认的品牌图片列表
  useEffect(() => {
    // 获取图片
    getBrandList({ ids }).then((value) => {
      const imgs = isArray(value) ? value : [];
      // 复制一份出来，用做闭店的图片
      const closeStyleImgs = imgs.map((item: any) => ({ ...item, frontendField }));
      const allImgs = [...imgs, ...closeStyleImgs];
      setImgList(allImgs);
    });
    // 获取七牛云token--都永久存，不用临时的bucket
    getUploadCustomToken({ bucket: Bucket.Certs }, true).then(({ token }) => {
      setToken(token);
    });
  }, []);
  // 开始合成
  useEffect(() => {
    if (imgList.length > 0 && canvasRefs.current.length && token && imgLoad) {
      // 开始第一个
      createPoster(canvasRefs.current[0], 0);
    }
  }, [imgList, token, imgLoad]);

  return (
    <div className={styles.container}>
      {
        imgList.map((item, index) => <div
          className={styles.card}
          key={index}
          ref={(el) => (canvasRefs.current[index] = {
            ref: el,
            extraData: item
          })}
        >
          <img
            className={styles.backgroundImg}
            id={backgroundImg}
            onLoad={() => {
              // setImgLoad(true);
              methods.checkAllLoaded();
            }}
            onError={() => {
              // console.log(`图片加载失败了`);
              methods.checkAllLoaded();
            }}
            src={item.frontendField === frontendField
              ? `${process.env.STATIC_RES_DOMAIN}/project-custom/locationpc/map/img_shell_close@6x.png`
              : `${process.env.STATIC_RES_DOMAIN}/project-custom/locationpc/map/img_shell_default@6x.png`}
            style={{
              ...(item.frontendField === frontendField ? { zIndex: 2 } : {}),
              // 其他样式
            }}
          />
          {item?.logo
            ? <img
              id={content}
              src={item?.logo}
              className={styles.content}
              style={
                item.frontendField === frontendField ? {
                  zIndex: 1,
                  border: 'none'
                } : {}
              }
            />
            : <span className={styles.content} >{item?.name || '-'}</span>}
        </div>)
      }
    </div>
  );
};

export default Canvas;
